import request from "./request";

export const getAdCount = (data) => request("/bi/getAdvertiserInfo", data, "POST_JSON");
//获取转化数据
export const getConvert = (data) => request("/toutiao/getConvert", data, "POST");
//新增转化数据
export const createConvert = (data) => request("/toutiao/createConvert", data, "POST_JSON");
//查询转化
export const queryConvert = (data) => request("/toutiao/queryConvert", data, "POST");
//推送
export const convertPush = (data) => request("/toutiao/convertPush", data, "POST");
//同步
export const snycConvertData = (data) => request("/toutiao/snycConvertData", data, "POST");
//删除
export const deleteAdConvert = (data) => request("/toutiao/deleteAdConvert", data, "POST");

///////////////////////////////////////////////////
/////////////////////////快手相关///////////////////
///////////////////////////////////////////////////
//获取转化数据
export const getConvert_k = (data) => request("/kuaishou/getConvert", data, "POST");
//人群包数据
export const getAudience_k = (data) => request("/kuaishou/getAudience", data, "GET");
//同步
export const loadKuaishouConvert = (data) =>
  request("/kuaishou/loadKuaishouConvert", data, "POST");

/* 广点通 */
// 转化管理查询
export const getConvert_gdt = (data) => request("/conversion/convertList", data, "POST");
// 转化管理数据同步
export const snycConvertData_gdt = (data) =>
  request("/conversion/syncConvert", data, "POST");
//转化归因授权
export const assetPermissions = (data) =>
  request("/conversion/assetPermissions", data, "POST");
// 获取推广应用列表
export const getPromotedAppList = (data) =>
  request("/tencent/campaign/promotedObjects", data, "POST");
// 优化目标权限
export const getOptimizationGoal = (data) =>
  request("/conversion/getOptimizationGoal", data, "POST");
//新增转化数据
export const createConvert_gdt = (data) => request("/conversion/addConvert", data, "POST");

// 标签管理
// 获取所有标签列表
export const getTagList = (data) => request("/tag/getTagList", data, "GET");
// 获取所有下拉标签列表
export const getSelectTagList = (data) => request("/tag/getSelectTagList", data, "GET");
// 获取编辑人
export const getOperatorList = (data) => request("/tag/getOperator", data, "GET");
// 删除标签
export const delTag = (data) => request("/tag/delTag", data, "GET");
// 新建标签
export const addTag = (data) => request("/tag/newTag", data, "GET");
// 修改标签
export const editTag = (data) => request("/tag/modifyTag", data, "POST_JSON");
// 标签类型管理
// 查询标签类型列表
export const getTagPropertyList = (data) =>
  request("/tag/queryTagPropertyList", data, "POST_JSON");
// 删除素材类型
export const delTagProperTY = (data) => request("/tag/delTagProperTY", data, "GET");
// 修改素材类型
export const modifyTagProperty = (data) =>
  request("/tag/modifyTagProperty", data, "POST_JSON");
// 添加素材类型
export const addTagProperty = (data) => request("/tag/saveTagProperty", data, "POST_JSON");
// 获取素材属性下拉列表
export const getTagPropertySelectList = (data) =>
  request("/tag/getTagPropertySelectList", data, "GET");
// 获取编辑人
export const getTagPropertyOperator = (data) =>
  request("/tag/getTagPropertyOperator", data, "GET");

// 命名解析管理
// 查询标签管理列表
export const queryAnalysisList = (data) =>
  request("/tagAnalysis/queryAnalysisList", data, "GET");
// 创建人列表
export const getTagCreatorList = (data) =>
  request("/tagAnalysis/getTagCreatorList", data, "GET");
// 更新人列表
export const getTagReviserList = (data) =>
  request("/tagAnalysis/getTagReviserList", data, "GET");
// 新增标签管理规则
export const addTagAnalysis = (data) =>
  request("/tagAnalysis/addTagAnalysis", data, "POST_JSON");
// 修改标签管理
export const modifyAnalysis = (data) =>
  request("/tagAnalysis/modifyAnalysis", data, "POST_JSON");
// 删除标签规则
export const deleteAnalysis = (data) => request("/tagAnalysis/deleteAnalysis", data, "GET");
// 标签规则下拉列表(树型)
export const getTagRuleList = (data) => request("/tagAnalysis/getRuleList", data, "GET");
// 制作人列表
export const getDesignerList = (data) => request("/tagAnalysis/getDesigner", data, "GET");
// 获取不同类型的规则下拉列表
export const getMaterialTagRuleList = (data) =>
  request("/tagAnalysis/getTagRuleList", data, "GET");
// 获取预览标签
export const getPreviewTag = (data) => request("/tagAnalysis/previewTag", data, "POST_JSON");
// youtube上传视频
// 获取视频播放列表
export const getPlaylists = (data) => request("/youtube/playlists", data, "GET");
// 获取素材列表
export const getYoutubeFiles = (data) => request("/youtube/youtubeFiles", data, "POST_JSON");
// 视频类别列表
export const getVideoCategories = (data) => request("/youtube/videoCategories", data, "GET");
// 频道列表
export const getChannelList = (data) => request("/youtube/channelList", data, "GET");
// 频道下拉列表
export const getChannelOptions = (data) => request("/youtube/getChannelList", data, "GET");
// 素材添加到youtube
export const addYoutubeFiles = (data) => request("/youtube/upload", data, "POST_JSON");
// 创建播放列表
export const savePlayList = (data) => request("/youtube/savePlayList", data, "GET");
// 新增youtube用户
export const addYoutubeUserInfo = (data, youtubeUserName) =>
  request(`/youtubeUserInfo/insert?youtubeUserName=${youtubeUserName}`, data, "POST_JSON");
// 查询youtube用户
export const getYoutubeUserList = (data) => request("/youtubeUserInfo/list", data, "GET");
// 查询有权限控制的youtube用户
export const getYoutubePermUserList = (data) =>
  request("/youtubeUserInfo/permList", data, "GET");
// 删除youtube用户
export const deleteYoutubeUser = (data) => request("/youtubeUserInfo/delete", data, "GET");
// 撤销授权
export const revokeYoutubeUser = (data) => request("/youtube/revoke", data, "GET");
// 修改youtube用户
export const updateYoutubeUserInfo = (data, youtubeUserName, id) =>
  request(
    `/youtubeUserInfo/update?youtubeUserName=${youtubeUserName}&id=${id}`,
    data,
    "POST_JSON"
  );
// 同步频道
export const refreshYoutubeChannel = (data) => request("/youtube/synChannel", data, "GET");
// 用户授权
export const authoriizeYoutubeUser = (data) => request("/youtube/permission", data, "GET");
// 同步youtube素材
export const refreshYouTubeVideoList = (data) =>
  request("/youtube/syncVideoList", data, "GET");
// 播放列表筛选项
export const getYouTubePlayList = (data) => request("/youtube/playList", data, "GET");
// 查询youtube用户--获取指定部门人员列表
export const getYoutubeUserPermList = (data) =>
  request("/youtubeUserInfo/permList", data, "GET");
// 关联系统用户
export const bindYoutubeUser = (data) => request("/youtubeUserInfo/bindUser", data, "GET");

// 批量上传数据
export const uploadBatchRecords = (data) => request("/product/uploadProducts", data, "POST_JSON");

//类型管理-获取平台类型
export const getPlatformType = () => request('/tag/getTypeBoxData', null, 'GET');

// 产品权限分配—新增用户列表接口
export const getProductUserList = () => request("/uapp/userInfos", null, "GET");

// 获取发布市场列表
export const getPublishMarketsList = () => request("/product/publishMarkets", null, "GET");
